import { AdjustmentsIcon } from "@icons";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import {
    requestOpenFeatureFlagsPanel,
    useCanShowDemoFeatureFlags,
} from "@components/featureFlags/featureFlagsPanel";
import { useCommands } from "./useCommands";

export const FeatureFlagsCommand = () => {
    const canShow = useCanShowDemoFeatureFlags();
    const { close } = useCommands();

    if (!canShow) {
        return null;
    }

    return (
        <CommandItem
            keywords={["feature flags", "flags", "overrides"]}
            onSelect={() => {
                close();
                window.setTimeout(requestOpenFeatureFlagsPanel, 0);
            }}
        >
            <AdjustmentsIcon /> Feature flags
        </CommandItem>
    );
};
